import { set, merge } from 'cerebral/operators'
import { state, props } from 'cerebral/tags'
import getCurrentMediaId from '../actions/getCurrentMediaId'
import hideFileContextMenu from 'modules/Media/chains/hideFileContextMenu'

export default [
  ...hideFileContextMenu,
  getCurrentMediaId,
  merge(state`media.details`, {
    preview: state`media.files.${props`id`}.preview`,
    scale: 1.0
  }),
  set(state`media.showDetail`, true)
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/onShowDetailedView.js